/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'Melissa & Doug Modeling Dough Kit<br/>dinosaur figures<br/>colored school glues',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XrY',
    },
    {
      stepDescription:
        'Flatten modeling dough to form a disk shape. Make it about 3/4” thick.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urh',
    },
    {
      stepDescription:
        'Squish your dinosaur figure into each disk. Make sure you get the features of the dino deep into the fossil, then peel your prehistoric pal out.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XrZ',
    },
    {
      stepDescription:
        'You’ll see the shape of the dinosaur in the dough. Fill the space in with colored glue.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urf',
    },
    {
      stepDescription:
        'You’ll see the shape of the dinosaur in the dough. Fill the space in with colored glue.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urg',
    },
    {
      stepDescription:
        'When thoroughly dry, peel out the glue. Eureka! You have a fossil AND a brand new type of dinosaur, the stegluesaurus!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZXU',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
